<!--

会員番号のバーコードを表示します。

ゴルフ場のスキャナー機器で来場者のスマートフォンに表示されたバーコードを読み取る時に使用します。

以下のモジュールを使用してバーコードを生成します。
https://lindell.me/JsBarcode/


会員番号のQRコードを表示します。

ゴルフ場のスキャナー機器で来場者のスマートフォンに表示されたQRコードを読み取る時に使用します。

以下のモジュールを使用してQRコードを生成します。
https://www.npmjs.com/package/qrcode

-->
<template>
    <div id="overlay">
        <div class="d-flex justify-content-center align-items-center" style="height: 100%; width: 100%;">
            <div>
                <div class="spBarcode__dispArea" v-show="!dysplayCode">
                    <div class="icon-qrcode pl-2 py-3">
                        <span class="ml-2" @click="dysplayCode = !dysplayCode">QRコードを表示</span>
                    </div>
                    <svg id="barcode" class="codeBorder px-3"></svg>
                    <span class="closeBtn" @click="closeEvent">×</span>
                </div>
                <div class="spBarcode__dispArea" v-show="dysplayCode">
                    <div class="icon-barcode pl-2 py-3">
                        <span class="ml-2" @click="dysplayCode = !dysplayCode">バーコードを表示</span>
                    </div>
                    <div style="height: auto; width: 65%; margin: auto;" class="codeBorder" v-html="qrCode"></div>
                    <span class="closeBtn" @click="closeEvent">×</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { memberNumberMixin } from '../../../mixins/MyPage/memberNumberMixin';
import JsBarcode from 'jsbarcode';
import QRCode from 'qrcode';

export default {
    mixins: [
        memberNumberMixin
    ],
    props: {
        golfGroupCode: {
            type: String,
            required: true,
        },
        memberNo: {
            type: String,
            required: true,
        },
        defaultCode: {
            type: Number,
            required: true,
        }
    },
    data () {
        return {
            isShow: false,
            qrCode: '',
            dysplayCode: this.defaultCode
        };
    },
    mounted() {
        this.initialize();
    },
    computed: {
        setHeadIcon() {
            return this.dysplayCode ? 'icon-qrcode' : 'icon-barcode';
        }
    },
    methods: {
        async initialize() {
            this.makeDisplayCode();
        },
        async makeDisplayCode() {
            const memberNumber = this.getReadableMemberNumberByScannerDevice(
                this.golfGroupCode,
                this.memberNo,
            );
            JsBarcode("#barcode", memberNumber, {
                format: "CODE39",
                width: 1.2,
                displayValue: false
            });
            this.qrCode = await (() => {
                return new Promise((resolve) => {
                    QRCode.toString(memberNumber, {type: 'svg'}, function (err, str) {
                        resolve(str);
                    });
                });
            })();
        },
        closeEvent() {
            this.$emit('close-modal');
        }
    }
}
</script>

<style scoped>
.titlleArea {
    background-color: #30BAAF;
    border-top-right-radius: 0.2rem;
    border-top-left-radius: 0.2rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.titleText {
    font-size: 1.2rem;
}
.closeBtn{
    font-size: 2rem;
    padding-left: 8px;
    padding-right: 8px;
    font-weight: bold;
    cursor: pointer;
}
</style>
